import { Info } from "lucide-react";
import { Alert } from "@shared-kernel/primary/shared/alert";
import { CustomCard } from "@shared-kernel/primary/shared/custom-card/custom-card";
import { cn } from "@components/utils/utils";
import type { ReactNode } from "react";

export interface ReadOnlyProfileRow {
  label: string;
  value: ReactNode;
}

interface Props {
  title: string;
  rows: ReadOnlyProfileRow[];
  className?: string;
}

const EMPTY_VALUE = "—";

const renderValue = (value: ReactNode) => {
  if (value === null || value === undefined || value === "") return <span className="text-muted-foreground">{EMPTY_VALUE}</span>;
  return value;
};

export const ReadOnlyProfileBlock = ({ title, rows, className }: Props) => (
  <CustomCard title={title} cardClassname={className}>
    <div className="flex w-full flex-col gap-4">
      <Alert variant="info">
        <div className="flex items-start gap-2">
          <Info className="mt-0.5 size-4 shrink-0" />
          <p className="text-sm">
            Ces informations ne peuvent être modifiées que par l&apos;utilisateur lui-même. Utiliser « Se faire passer pour cet utilisateur
            » pour les modifier en son nom.
          </p>
        </div>
      </Alert>
      <dl className="grid w-full grid-cols-1 gap-x-6 gap-y-3 sm:grid-cols-2">
        {rows.map(({ label, value }) => (
          <div key={label} className={cn("flex flex-col gap-1")}>
            <dt className="text-sm text-muted-foreground">{label}</dt>
            <dd className="text-sm font-medium text-foreground">{renderValue(value)}</dd>
          </div>
        ))}
      </dl>
    </div>
  </CustomCard>
);
